<template>
  <div class="edit-terminal">
    <el-button
      type="text"
      icon="el-icon-setting"
      size="medium"
      @click="dialogVisible = true"
    ></el-button>
    <el-dialog
      title="Настройка Apple Pay"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="grid">
        <div class="u-16">
          <p class="description">
            Скачайте файл запроса подписи сертификата (CSR). Используя
            полученный CSR, создайте сертификат в партнёрском центре Apple.
          </p>
          <br />

          <el-button icon="el-icon-download" type="primary">
            Скачать CSR
          </el-button>
        </div>
        <hr class="u-16" />
        <p class="description">Загрузите созданный сертификат.</p>
        <el-upload
          class="u-16"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :file-list="fileList"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Перетащите файл сюда или <em>кликните для загрузки</em>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="dialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";

export default {
  name: "editTerminal",
  props: ["terminalName"],
  data() {
    return {
      dialogVisible: false,
      fileList: []
    };
  },
  computed: {},
  methods: {}
};
</script>

<style lang="sass" slot>
.description
  word-break: break-word
  font-size: 13px
  line-height: 1.5
.el-upload
  margin-top: 20px
  width: 100%
  .el-upload-dragger
    width: 100%
    height: 100px
    .el-icon-upload
      font-size: 36px
      margin: 10px 0 0
    .el-upload__text
      font-size: 11px
</style>
